// src/components/FaunaRace/FaunaDifficultyScreen.js
import React from 'react';
import styles from './FaunaRace.module.css';
import { ACTIONS } from './FaunaRaceGame';

const difficulties = ['easy', 'medium', 'pro'];

function FaunaDifficultyScreen({ dispatch }) {
    return (
        <div className={styles.container}>
             <div className={styles.modeScreen}>
                <h2 className={styles.modeTitle}>PILIH TINGKAT KESULITAN</h2>
                <div className={styles.modeGrid}>
                    {difficulties.map(diff => (
                         <div key={diff} className={styles.modeButton} onClick={() => dispatch({ type: ACTIONS.SELECT_DIFFICULTY, payload: { difficulty: diff } })}>
                            <div className={styles.modeLabel}>{diff.toUpperCase()}</div>
                        </div>
                    ))}
                </div>
                <button className={`${styles.woodButton} ${styles.backButton}`} onClick={() => dispatch({ type: ACTIONS.GO_TO_SCREEN, payload: { screen: 'mode' } })}>
                    Kembali
                </button>
            </div>
        </div>
    );
}

export default FaunaDifficultyScreen;